import { Grid } from '@material-ui/core'
import { useEffect, useState } from 'react'
import { useTranslate } from 'react-admin'
import useStyles from '../styles'
import { isActionRequired, isLastStep } from '../utils'
import AlertMessage from './AlertMessage'
import ButtonActionWrapper from './Buttons/ButtonActionWrapper'
import CtaDescription from './CtaDescription'
import HandlingInputs from './HandlingInputs'

const FormStep = ({ record, refresh, setRefresh }) => {
  const classes = useStyles()
  const [payload, setPayload] = useState({})
  const [isError, setIsError] = useState(false)
  const [open, setOpen] = useState(false)
  const [message, setMessage] = useState('')
  const [errors, setErrors] = useState([])
  if (!record.state_transition) {
    return null
  }
  return (
    <Grid container justifyContent="center" className={classes.spacing}>
      <Grid item xs={11} md={6}>
        <form className={classes.paper}>
          <CtaDescription record={record} />
          <AlertMessage
            isError={isError}
            message={message}
            setMessage={setMessage}
            open={open}
            setOpen={setOpen}
            errors={errors}
          />
          <HandlingInputs
            record={record}
            setPayload={setPayload}
            payload={payload}
            setRefresh={setRefresh}
            refresh={refresh}
            setErrors={setErrors}
            errors={errors}
          />
          <ButtonActionWrapper
            setErrors={setErrors}
            errors={errors}
            setRefresh={setRefresh}
            refresh={refresh}
            record={record}
            payload={payload}
            setIsError={setIsError}
            setOpen={setOpen}
            setMessage={setMessage}
          />
        </form>
      </Grid>
    </Grid>
  )
}

export default FormStep
